import {
  EmploymentsHiringCompanyProcessStepName,
  EmploymentsHiringEmployeeProcessStepName,
  OtpStatusType,
} from "@oysterhr/schema"

const COMPANY_DISABLE_CHANGES_STEPS = [
  EmploymentsHiringCompanyProcessStepName.WaitingForSignatures,
  EmploymentsHiringCompanyProcessStepName.Completed,
]

const EMPLOYEE_DISABLE_CHANGES_STEPS = [
  EmploymentsHiringEmployeeProcessStepName.WaitingForSignatures,
  EmploymentsHiringEmployeeProcessStepName.Completed,
]

export const disableAgreementFieldsSteps = [
  ...COMPANY_DISABLE_CHANGES_STEPS,
  ...EMPLOYEE_DISABLE_CHANGES_STEPS,
]

export interface TwoFactorAuthNavigationState {
  originPathname?: string
  successfulReset?: boolean
  successfulSetup?: boolean
  otpRecoveryTokens?: string[]
}

export const DASHBOARD_2FA_SETUP_MODAL_SKIPPED_KEY = "DASHBOARD_2FA_SETUP_MODAL_SKIPPED"
export const OTP_STATUSES_FOR_ENABLED = [OtpStatusType.Enabled, OtpStatusType.EnabledEmail]
export const VALID_OTP_STATUSES_FOR_SETUP = [
  OtpStatusType.Mandatory,
  OtpStatusType.MandatorySoon,
  OtpStatusType.Optional,
]
export const SETUP_2FA_PATH = "/profile/2fa-setup"
export const ZENDESK_2FA_SETUP_SUPPORT_ARTICLE_HREF =
  "https://support.oysterhr.com/hc/en-us/articles/33879024196497"
export const ZENDESK_2FA_FORBIDDEN_SETUP_SUPPORT_ARTICLE_HREF =
  "https://support.oysterhr.com/hc/en-us/articles/34081029090577"
